/**
 * @generated SignedSource<<ba2c856b1dcb2247034b00bddcae825c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSchedulerSuggestedTimes_org$data = {
  readonly id: string;
  readonly experiments: ReadonlyArray<string | null> | null;
  readonly workingGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly rooms: ReadonlyArray<{
          readonly roomId: string;
          readonly name: string;
        } | null> | null;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "EventSchedulerSuggestedTimes_org";
};
export type EventSchedulerSuggestedTimes_org$key = {
  readonly " $data"?: EventSchedulerSuggestedTimes_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerSuggestedTimes_org">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSchedulerSuggestedTimes_org",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "experiments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000000
        }
      ],
      "concreteType": "WorkingGroupConnection",
      "kind": "LinkedField",
      "name": "workingGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkingGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WorkingGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Room",
                  "kind": "LinkedField",
                  "name": "rooms",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "roomId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "workingGroups(first:1000000)"
    }
  ],
  "type": "Org",
  "abstractKey": null
};

(node as any).hash = "4c451f9be0ff4b29fb312769e2b750b9";

export default node;
